import { useDispatch, useSelector } from "react-redux";
import { addCachedAsset, selectCachedAsset, selectCachedAssets } from "../app/slices/AssetsSlice";
import { selectToken } from "../app/slices/AuthenticationSlice";
import { selectCurrentOrganization } from "../app/slices/UserSlice";
import { AssetService } from "../services/AssetService";
import { selectCurrentLanguage } from "../app/slices/TrainingLocalizationSlice";
import { resolveVariant } from "../features/variants/resolveVariant";

export const useAssetPreview = (assetId: string | undefined) => {
  const cachedAsset = selectCachedAsset(useSelector(selectCachedAssets), assetId);
  // The project language picks the variant, so the preview shows what that language plays.
  const languageCode = useSelector(selectCurrentLanguage)?.shortcode;
  const previewUrl = resolveVariant(cachedAsset?.variants, languageCode)?.downloadUri;
  const assetName = cachedAsset?.name;

  var orgId = useSelector(selectCurrentOrganization)?.id;
  var token = useSelector(selectToken);
  const dispatch = useDispatch();

  const fetchAsset = async (content: boolean) => {
    if (!orgId || !assetId) return;

    var asset = await AssetService.GetAssetByGuid(orgId, token, assetId, content, "large");

    if (asset) {
      dispatch(addCachedAsset(asset));
    }
  };

  const getAssetPreview = () => {
    if (!previewUrl) {
      fetchAsset(false);
    }

    return previewUrl;
  };

  const getAssetPreviewRaw = () => {
    if (!previewUrl) {
      fetchAsset(true);
    }

    return previewUrl;
  };

  const getAssetName = () => {
    if (!assetName) {
      fetchAsset(false);
    }
    return assetName;
  };

  return { getAssetPreview, getAssetPreviewRaw, getAssetName } as const;
};
